/* @flow */

import { responseHasError } from '../diplomatico/reducers/helper';
import type { Action } from '../diplomatico/types';
import { enableInitializing } from 'initializable-reducer';
import mergeWithReplace from '../helpers/mergeWithReplace';

const initialState = {};

function studentComments(state: Array<Object> = initialState, { type, payload }: Action) {
  switch (type) {
    case 'RESPONSE_STUDENT_COMMENTS':
    case 'RESPONSE_STUDENT_COMMENT_CREATE':
    case 'RESPONSE_STUDENT_COMMENT_DELETE':
    case 'RESPONSE_STUDENT_COMMENT_UPDATE':
      if (responseHasError(payload)) {
        return state;
      }

      const { student_id } = payload._meta.payload.request;

      const newComments = {
        [student_id]: payload.body
      };

      return mergeWithReplace({}, [state, newComments]);
    default:
      return state;
  }
}

export {
  studentComments,
  initialState
};

export default enableInitializing(studentComments);
